import {ListItem} from '@github-ui/list-view/ListItem'
import {ListItemTitle} from '@github-ui/list-view/ListItemTitle'
import type {RepoStackSummary} from '@github-ui/dotcom-schema/types/pull_requests/v1/repo_stacks'
import {Link} from '@github-ui/react-router'
import {memo} from 'react'

import {StackClosedPullWarning} from './StackClosedPullWarning'
import {StackProgress} from './StackProgress'
import styles from './Stacks.module.css'

export const StackListRow = memo(function StackListRowComponent({stack}: {stack: RepoStackSummary}) {
  return (
    <ListItem
      role="listitem"
      className={styles.row}
      title={
        <ListItemTitle
          value={`#${stack.number}`}
          href={stack.url}
          linkProps={{as: Link, to: stack.url}}
          containerClassName={styles.rowTitle}
        >
          <StackClosedPullWarning closedPullRequest={stack.closedPullRequest} className={styles.rowWarning} />
        </ListItemTitle>
      }
      metadata={<StackProgress mergedCount={stack.mergedCount} unmergedCount={stack.unmergedCount} />}
      metadataContainerClassName={styles.rowMetadata}
    />
  )
})
